import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * Provide a reactive `lang` attribute value for native date inputs so that
 * their localized placeholders match the active UI language.
 *
 * @returns {{ dateInputLang: import('vue').ComputedRef<string> }}
 */
export function useDateInputLang() {
  const { locale } = useI18n();
  const dateInputLang = computed(() => (locale.value === 'zh-CN' ? 'zh-CN' : 'en-US'));
  return { dateInputLang };
}
